
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/investments/add-to-app",
      function () {
        return require("private-next-pages/docs/investments/add-to-app.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/investments/add-to-app"])
      });
    }
  